const axios = require('axios')
const https = require('https')

const elastic = axios.create({
    headers: {
        'Content-Type': 'application/json'
    }
})

elastic.interceptors.request.use((config) => ({
    ...config,
    baseURL:
        process.env.ELASTIC_URL ||
        process.ELASTIC_URL ||
        'http://144.76.9.237:9201',
    headers: {
        ...config.headers
    },
    httpsAgent: new https.Agent({
        rejectUnauthorized: false
    })
}))

const strapi = axios.create({
    headers: {
        'Content-Type': 'application/json'
    }
})

strapi.interceptors.request.use((config) => ({
    ...config,
    baseURL:
        process.env.STRAPI_URL ||
        process.STRAPI_URL ||
        'https://backend.tutor.berlin',
    headers: {
        ...config.headers
    }
}))

module.exports = {
    elastic,
    strapi
}
